const GET_ASSIGNMENTS =
  `query GetAssignments($entityId: ID!, $entityType: Entity!,$defaultEntities: [DefaultEntity], $schoolYears: [Int]) {
    assignment(entityId: $entityId, entityType: $entityType, filter:{status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE],defaultEntities: $defaultEntities, schoolYears: $schoolYears}) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      tags
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        activity {
          activityId
          assignmentId
          displayStatus
          status
          createdAt
          updatedAt
          storyId
          tags
          type
        }
      }
    }
  }`;

export const CHECK_FOR_SCHOOL_WINDOWS =
  `query GetAssignments($entityId: ID!, $dateTo: String, $dateFrom: String, $schoolYears: [Int]) {
    assignment(entityId: $entityId, entityType: SCHOOL, filter:{status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE], dateTo: $dateTo, dateFrom: $dateFrom, entityType: SCHOOL, schoolYears: $schoolYears}) {
      assignmentId
      assignmentType
      status
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
    }
  }`;

export const GET_ASSIGNMENT =
  `query GetAssignment($assignmentId: ID!) {
    assignmentById(assignmentId: $assignmentId) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      tags
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        contentTags
        activity {
          activityId
          assignmentId
          displayStatus
          status
          createdAt
          updatedAt
          storyId
          tags
          type
        }
      }
    }
  }`;

export const GET_SPANISH_CALIBRATION_ASSIGNMENT =
  `query GetSpanishCalibrationAssignment($entityId: ID!, $entityType: Entity!, $filter: AssignmentQueryFilter) {
    assignment(entityId: $entityId, entityType: $entityType, filter: $filter) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      tags
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        activity {
          activityId
          assignmentId
          displayStatus
          status
          createdAt
          updatedAt
          storyId
          tags
          type
        }
      }
    }
  }`;

export default GET_ASSIGNMENTS;
